import { useId } from 'react';
import {
    FIELD_BORDER_CLASSES,
    FIELD_ERROR_BORDER_CLASSES,
    FIELD_WARNING_BORDER_CLASSES,
    FieldErrorText,
    FieldLabel,
    ResolveFieldMessage,
} from './Input';

/**
 * Select do DS. `hint`/`warning`/`labelAside` são opcionais e seguem a mesma
 * precedência do `Input` (erro → aviso → dica).
 */
const Select = ({ label, error, errorMessage, hint, warning, labelAside, className = '', children, ...props }) => {
    const generatedId = useId();
    const fieldId = props.id || generatedId;
    const hasError = Boolean(error || errorMessage);
    const errorText = FieldErrorText(error, errorMessage);
    const message = ResolveFieldMessage({ fieldId, errorText, warning, hint });
    const borderClasses = hasError
        ? FIELD_ERROR_BORDER_CLASSES
        : warning
          ? FIELD_WARNING_BORDER_CLASSES
          : FIELD_BORDER_CLASSES;

    return (
        <div className="w-full">
            <FieldLabel htmlFor={fieldId} label={label} labelAside={labelAside} />

            <select
                id={fieldId}
                aria-invalid={hasError || undefined}
                aria-describedby={message.id}
                className={`w-full px-4 py-2 text-base border rounded-lg transition-all duration-200 focus:outline-none focus:ring-1
          ${borderClasses}
          bg-white dark:bg-mono-950 text-black dark:text-white disabled:bg-mono-100 dark:disabled:bg-mono-900 disabled:cursor-not-allowed
          ${className}`}
                {...props}
            >
                {children}
            </select>

            {message.node}
        </div>
    );
};

export default Select;
